<template>
  <div>
    <headers />
    <div class="bg-box">
      <!-- <img src="../../assets/home/bannergy.png" alt="" /> -->
      <div class="textes">
        <div>
          <span>公司理念</span><br/>
          <span>希望用专业、极致的服务，用数据助力企业腾飞</span>
        </div>
      </div>
    </div>
    <div class="banner-wrap">
        <Texts/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Headers from "@/components/Header/index.vue";
import Texts  from "./texts.vue"
import Footer  from "../Home/components/Footer.vue"
export default {
  components: {
    Headers,
    Texts,
    Footer
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.bg-box {
  padding-top: 20px;
  width: 100%;
  margin: 80px 0 0px;
  height: 180px;
  background: url('../../assets/home/bannergy.png') no-repeat;
  line-height: 80px;
  img {
    width: 100%;
    // height: 100%;
  }
  .textes {
    display: flex;
    justify-content: center;
    font-size: 36px;
    color: #fff;
    line-height: 55px;
    div{
      font-size: 36px;
font-family: Source Han Sans CN;
font-weight: bold;
color: #FEFEFE !important;
line-height: 64px;
text-shadow: 0px 2px 6px rgba(0, 66, 255, 0.18) !important;
    }
  }
}
.banner-wrap{
    display: flex;
    justify-content: center;
    padding-top: 20px;
    background: url('../../assets/use-course/course-bg.png') no-repeat;
    background-size: 100% 528px;
}
</style>
